import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {IdIsimDto} from '../model/id-isim-dto';
import {ActivatedRoute, Router} from '@angular/router';
import {RestService} from '../providers/rest.service';
import {ToastrService} from 'ngx-toastr';
import {TalepTur} from '../model/talep-tur';

@Component({
  selector: 'app-talep-tur-ekle-duzenle',
  templateUrl: './talep-tur-ekle-duzenle.component.html',
  styleUrls: ['./talep-tur-ekle-duzenle.component.css']
})
export class TalepTurEkleDuzenleComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  id: string = null;
  talepTur: TalepTur = null;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private restService: RestService,
              private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.id = params.id;
      if (this.id !== '0') {
        this.getTalepTur();
      } else {
        this.talepTur = new TalepTur();
        this.talepTur.isim = '';
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getTalepTur() {
    this.restService.getTalepTur(this.id).subscribe(res => {
      if (res) {
        this.talepTur = res;
      }
    });
  }

  save() {
    const subscription = res => {
      this.toastrService.show('Kaydedildi', 'Başarılı');
      this.router.navigate(['talep-turler']);
    };
    if (this.id === '0') {
      this.restService.talepTurEkle(this.talepTur).subscribe(subscription);
    } else {
      this.restService.talepTurDuzenle(this.talepTur).subscribe(subscription);
    }
  }
}

